import * as types from "./types";

const INITIAL_STATE = {
  isFetchingEventData: false,
  eventData: null,
  errors: null,
};

export const sharedEventsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.FETCH_SHARED_EVENT_DATA_REQUEST:
      return {
        ...state,
        isFetchingEventData: true,
      };

    case types.FETCH_SHARED_EVENT_DATA_SUCCESS:
      return {
        ...state,
        isFetchingEventData: false,
        eventData: action.payload,
      };

    case types.FETCH_SHARED_EVENT_DATA_FAILURE:
      return {
        ...state,
        isFetchingEventData: false,
        errors: action.error,
      };

    default:
      return state;
  }
};
